var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgBoxGreenMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 81,
    viewBox: "0 0 275 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_15)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 275,
    height: 81,
    fill: "#C6F9E4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 275,
    height: 81,
    fill: "url(#paint0_linear_4_15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.091 72.199V76.6667H264.545V81H239.455V76.6667H249.909V72.199C245.867 71.6708 242.149 69.6321 239.455 66.4655C236.76 63.2988 235.273 59.222 235.273 55V42H268.727V55C268.727 59.222 267.24 63.2988 264.545 66.4655C261.851 69.6321 258.133 71.6708 254.091 72.199V72.199ZM239.455 46.3333V55C239.455 58.4478 240.776 61.7544 243.129 64.1924C245.482 66.6304 248.673 68 252 68C255.327 68 258.518 66.6304 260.871 64.1924C263.224 61.7544 264.545 58.4478 264.545 55V46.3333H239.455ZM229 46.3333H233.182V55H229V46.3333ZM270.818 46.3333H275V55H270.818V46.3333Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_15",
    x1: 8.69253,
    y1: 63,
    x2: 276.645,
    y2: 52.7026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06ED8D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 275,
    height: 81,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBoxGreenMobile);
export default __webpack_public_path__ + "static/media/bg-box-green-mobile.88c7b3964557ca7341715b61235cb49a.svg";
export { ForwardRef as ReactComponent };